'use strict';

import {
	RESET_STATE,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	SET_PRODUCT_BUNDLE_SETS,
	UPDATE_PRODUCT_BUNDLE_SET,
	ADD_BATCH_LIST_ITEM_ROW
} from './productBundleSets.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		productBundleSet: {},
		defaultProductBundleSet: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				name: '',
				description: '',
				sortOrder: null,
				productRecommendation: null,
				optional: false
			}
		]
	}
};

function reducer(state = defaultState, action) {
	const { payload, type } = action;

	switch (type) {
	case EDIT_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchList: state.data.batchList.map(entry => {
					if (entry.identifier === payload.identifier) return payload;
					return entry;
				})
			}
		};
	}

	case REMOVE_BATCH_LIST_ITEM: {
		return {
			...state,
			data: {
				...state.data,
				batchList: state.data.batchList.filter(
					entry => entry.identifier !== payload
				)
			}
		};
	}

	case SET_PRODUCT_BUNDLE_SETS: {
		return {
			...state,
			data: {
				...state.data,
				productBundleSet: payload,
				defaultProductBundleSet: payload
			}
		};
	}

	case UPDATE_PRODUCT_BUNDLE_SET: {
		return {
			...state,
			data: {
				...state.data,
				productBundleSet: {
					...state.data.productBundleSet,
					...payload
				}
			}
		};
	}

	case ADD_BATCH_LIST_ITEM_ROW: {
		return {
			...state,
			data: {
				...state.data,
				batchList: [
					...state.data.batchList,
					{
						...defaultState.data.batchList[0],
						identifier: _uniqueId('row-')
					}
				]
			}
		};
	}

	case RESET_STATE: {
		return defaultState;
	}

	default:
		// never return default state in default case, Filip!!!
		return state;
	}
}

export default reducer;
